<template>
  <div>
    <div ref="chartContainer" style="width: 100%; height: 600px;margin-bottom: 50px" />
  </div>
</template>

<script>
import echarts from 'echarts'

export default {
  name: 'StatBar',
  props: {
    title: {
      type: String,
      default: () => '产出统计'
    }
  },
  data() {
    return {
      chart: {},
      option: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          text: this.title
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          data: [],
          // type: 'scroll'
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '18%',
          containLabel: true
        },
        yAxis: {
          type: 'value'
        },
        toolbox: {
          show: true
        },
        tooltip: {
          trigger: 'axis',
          formatter: function(params) {
            var tooltipContent = ''
            params.forEach(function(item) {
              if (item.value > 0) {
                tooltipContent += item.seriesName + ' : ' + item.value + '<br/>'
              }
            })
            return tooltipContent
          }
        },
        series: [

        ]
      }
      this.chart.setOption(this.option)
    },
    updateChart(titleArr, date, echart) {
      this.initChart()
      for (const i in echart) {
        const temp = {
          name: i,
          data: echart[i],
          type: 'bar',
          label: {
            // show: true,
            position: 'top', // 标签显示在折线图顶部
            formatter: '{c}' // 显示数值
          }
        }
        this.option.series.push(temp)
      }
      if (this.title === '产出统计') {
        this.option.grid.bottom = '25%'
      }
      this.option.xAxis.data = date
      this.option.legend.data = titleArr
      this.chart.setOption(this.option, true)
    }
  }
}
</script>

<style scoped>

</style>
